import { createTheme } from '@mui/material/styles';
import { themeSettings } from './settings';

export const theme = createTheme(themeSettings);
